"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Apacherocketmq = function Apacherocketmq(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M12,24c-1.89-1.755-1.813-3.743-1.813-3.743h3.626C13.813,20.257,13.89,22.245,12,24z M12,1.988 c-1.595,2.106-4.693,6.893-4.693,12.291c0,1.562,0.293,2.87,0.589,3.793h8.208c0.296-0.923,0.589-2.231,0.589-3.793 C16.693,8.881,13.595,4.094,12,1.988z M17.95,14.279c0,3.556-1.363,5.903-1.363,5.903l-1.458-0.853H8.871l-1.458,0.853 c0,0-1.363-2.347-1.363-5.903C6.05,6.446,11.998,0.002,12,0C12.002,0.002,17.95,6.446,17.95,14.279z M18.773,16.614 c0,1.363-0.605,2.845-1.022,3.47h2.889l-0.32-1.965L18.773,16.614z M3.68,18.12l-0.32,1.965h2.889 c-0.418-0.625-1.022-2.107-1.022-3.47L3.68,18.12z M10.867,12.448c-0.154,0-0.279,0.125-0.279,0.279s0.125,0.279,0.279,0.279 s0.279-0.125,0.279-0.279S11.021,12.448,10.867,12.448z M11.762,12.448c-0.154,0-0.279,0.125-0.279,0.279s0.125,0.279,0.279,0.279 s0.279-0.125,0.279-0.279S11.916,12.448,11.762,12.448z M12.657,12.448c-0.154,0-0.279,0.125-0.279,0.279s0.125,0.279,0.279,0.279 s0.279-0.125,0.279-0.279S12.811,12.448,12.657,12.448z M15.715,15.98c0,0.799-0.647,1.446-1.446,1.446 c-0.799,0-1.446-0.647-1.446-1.446c0-0.262,0.071-0.507,0.192-0.719l-0.361-0.493c-0.273,0.12-0.575,0.187-0.892,0.187 c-0.551,0-1.054-0.201-1.443-0.532l-0.403,0.35c0.013,0.059,0.02,0.119,0.02,0.181c0,0.478-0.387,0.865-0.865,0.865 c-0.478,0-0.865-0.387-0.865-0.865s0.387-0.865,0.865-0.865c0.104,0,0.202,0.021,0.294,0.055l0.429-0.373 c-0.166-0.312-0.261-0.667-0.261-1.045c0-0.506,0.171-0.971,0.455-1.345l-0.451-0.49c-0.033,0.004-0.065,0.01-0.098,0.01 c-0.406,0-0.735-0.329-0.735-0.735c0-0.406,0.329-0.735,0.735-0.735c0.406,0,0.735,0.329,0.735,0.735 c0,0.055-0.007,0.109-0.019,0.161l0.455,0.495c0.337-0.204,0.73-0.324,1.153-0.324c0.398,0,0.771,0.106,1.094,0.288l0.385-0.385 c-0.04-0.116-0.063-0.241-0.063-0.371c0-0.632,0.512-1.144,1.144-1.144c0.632,0,1.144,0.512,1.144,1.144 c0,0.632-0.512,1.144-1.144,1.144c-0.13,0-0.255-0.023-0.371-0.063l-0.353,0.353c0.247,0.359,0.393,0.793,0.393,1.262 c0,0.551-0.201,1.054-0.531,1.442l0.329,0.449c0.151-0.053,0.312-0.084,0.481-0.084C15.068,14.534,15.715,15.182,15.715,15.98z M11.762,14.481c0.969,0,1.754-0.785,1.754-1.754c0-0.969-0.785-1.754-1.754-1.754c-0.969,0-1.754,0.785-1.754,1.754 C10.008,13.695,10.793,14.481,11.762,14.481z"
  }));
};

Apacherocketmq.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Apacherocketmq.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Apacherocketmq;
exports.default = _default;